import { Scale } from '@react-types/provider'
import { Theme } from '@react-types/provider'
import { useMediaQuery } from '@react-spectrum/utils'

export const useScale = (theme: Theme | null): Scale => {
  let matchesFine = useMediaQuery('(any-pointer: fine)')
  if (matchesFine && theme && theme.medium) {
    return 'medium'
  }

  if (theme && theme.large) {
    return 'large'
  }

  return 'medium'
}
